<amount-spinner
  #amount_spinner
  inputId="markup"
  [disabled]="disabled || auxCheckbox.enabled && !auxCheckbox.value"
  [externalState]="data.state"
  [locked]="locked || disabled && auxCheckbox.enabled == false"
  stepType="PIP"
  [label]="label"
  [showValidationBar]="true"
  [currency]="currency"
  [ngModel]="data.numValue"
  (ngModelChange)="onStepperChange()"
  (focus)="onFocus()"
  (blur)="onBlur()"
  [min]="config.minValue"
  [max]="config.maxValue"
  [minMaxTouchValid]="config.minMaxTouchValid"
  [size]="'sm'"
  [inputStartContainer]="inputStartContainer"
  [bfxTooltip]="!(locked || disabled && auxCheckbox.enabled == false) && data.errorMsg ? data.errorMsg : null"
  tooltipPosition="top"
  tooltipStyleClass="bfx-tooltip-negative-bold"
>
  <ng-template #inputStartContainer let-chkBoxLabel>
    <p-checkbox
      [ngClass]="{
        'bfx-checkbox-enable-control': true,
        'icd__base__checkbox': true,
        'icd__base__checkbox--checked-active': auxCheckbox.value && !auxCheckbox.locked && !locked && !disabled,
        'icd__base__checkbox--checked-disabled': auxCheckbox.value && auxCheckbox.locked && !locked && !disabled,
        'icd__base__checkbox--unchecked-active': !auxCheckbox.value && auxCheckbox.locked && !locked && !disabled,
        'icd__base__checkbox--unchecked-disabled': !auxCheckbox.value && !auxCheckbox.locked && !locked && !disabled,
        'icd__base__checkbox--locked': disabled || locked
      }"
      binary="true"
      [disabled]="auxCheckbox.locked || disabled || locked || auxCheckbox.permanentLock"
      [style.display]="auxCheckbox.enabled ? 'flex' : 'none'"
      [bfxInputLabelOnClick]="chkBoxLabel"
      [(ngModel)]="auxCheckbox.value"
      (onChange)="onAuxCheckboxChange()"
    >
    </p-checkbox>
  </ng-template>
</amount-spinner>
